module.exports = __webpack_public_path__ + "static/media/42x40-13.8b4d5867.png";